<template>
  <div :class="{ 'theatre-mode-video': fullscreenVideo }">
    <img
      v-if="overlay.imageURL && !videoFile"
      class="video-frame cover"
      :src="overlay.imageURL"
    />
    <video v-else-if="videoFile && overlay" muted autoplay loop>
      <source :src="overlay.imageURL" type="video/mp4" />
    </video>
    <iframe
      v-else
      :src="closedCaptions && cc ? cc : src"
      frameborder="0"
      autoplay
      allowfullscreen
      allow="autoplay;fullscreen"
      class="video-frame"
    ></iframe>
    <button
      v-if="landingPage.fullScreenEnabled"
      class="video-control-button button w-button donate-button"
      :style="
        'color:' +
        landingPage.themeColor +
        ';background:' +
        landingPage.negativeColor
      "
      @click="enableFullscreenVideo"
    >
      {{ fullscreenVideo ? "" : "" }}
    </button>
  </div>
</template>

<script>
export default {
  name: "bgl-embed",
  props: {
    landingPage: Object,
    src: String,
    cc: String,
    overlay: [Object, String],
  },
  data() {
    return {
      fullscreenVideo: false,
    };
  },
  methods: {
    enableFullscreenVideo() {
      this.fullscreenVideo = !this.fullscreenVideo;
      this.$emit("fullscreen", this.fullscreenVideo);
    },
  },
  computed: {
    closedCaptions() {
      return window.location.href.match("cc.tinaswishbenefit");
    },
    videoFile() {
      if (!this.overlay) return false;
      return this.overlay.imageURL.match(/mp4|mpeg|avi/);
    },
  },
};
</script>

<style scoped>
video {
  width: 100%;
  border-radius: 10px;
  box-shadow: 1px 1px 20px 0 rgba(0, 0, 0, 0.15);
}
.cover {
  height: auto;
  max-height: none;
}

.theatre-mode-video {
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 75vw;
  padding: 0;
  z-index: 9999;
  background-color: black;
  overflow: no-content;
}

.video-control-button {
  opacity: 0.6;
  font-family: "bagelfont";
  width: 50px;
  margin: 1px -26px 1px 1px;
  transform: translate(-10px, -34px);
}
.video-control-button {
  transform: translate(-10px, -34px);
}
.fullscreen-mode .video-control-button {
  transform: translate(-0px, -0px);
}
.video-control-button:focus {
  outline: none !important;
}

@media screen and (max-width: 1280px) {
  .video-control-button {
    margin-right: -20px;
  }
}

@media screen and (max-width: 900px) {
  .video-control-button {
    display: none;
  }
}
</style>